function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { useCallback, useMemo, useState } from 'react';
import useAsync from '../useAsync';
import useDebounceFn from '../useDebounceFn';
import useUpdateEffect from '../useUpdateEffect';

function useSearch(fn, deps, options) {
  var _deps = Array.isArray(deps) ? deps : [];

  var _options = _typeof(deps) === 'object' && !Array.isArray(deps) ? deps : options || {};

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useAsync = useAsync(fn, [value].concat(_toConsumableArray(_deps)), {
    manual: true
  }),
      loading = _useAsync.loading,
      data = _useAsync.data,
      run = _useAsync.run,
      cancelAsync = _useAsync.cancel;

  var wait = useMemo(function () {
    return _options.wait === undefined ? 300 : _options.wait;
  }, [_options.wait]);
  var debounce = useDebounceFn(function () {
    run(value);
  }, [value], wait);
  /* 依赖变化时，需要立即重新请求 */

  useUpdateEffect(function () {
    run(value);
  }, _deps);
  var cancel = useCallback(function () {
    /* 先取消防抖 */
    debounce.cancel();
    /* 再取消 async */

    cancelAsync();
  }, [cancelAsync, debounce.cancel]);
  /* 手动触发 */

  var trigger = useCallback(function () {
    run(value);
  }, [run, value]);
  return {
    data: data,
    loading: loading,
    value: value,
    onChange: setValue,
    cancel: cancel,
    run: trigger
  };
}

export default useSearch;